module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/companies/companies.component.css
// module id = ./src/app/companies/companies.component.css
// module chunks = main